var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2064_7913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1123 21.0384L21.8086 22.3451H12.8779L14.1514 21.0384H23.1123ZM23.1143 18.7386H14.1523L12.877 17.43L21.8076 17.429L23.1143 18.7386ZM23.1348 13.8206L21.8057 15.1869H12.8564L14.1562 13.8206H23.1348Z",
    stroke: "#4F5372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8C23.522 8 28 12.5469 28 18.1538C28 23.7608 23.522 28.3077 18 28.3077C12.478 28.3077 8 23.7608 8 18.1538C8 12.5469 12.478 8 18 8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6244 17.1851H21.8784C21.9944 17.1851 22.1044 17.2318 22.1844 17.3151L23.6484 18.8118C23.9184 19.0879 23.7264 19.5591 23.3424 19.5591H14.0884C13.9724 19.5591 13.8624 19.5124 13.7824 19.4291L12.3184 17.9324C12.0464 17.6562 12.2404 17.1851 12.6244 17.1851ZM12.3184 15.201L13.7824 13.7044C13.8644 13.6211 13.9744 13.5744 14.0884 13.5744H23.3404C23.7244 13.5744 23.9184 14.0455 23.6464 14.3217L22.1844 15.8184C22.1024 15.9017 21.9924 15.9484 21.8784 15.9484H12.6244C12.2404 15.9484 12.0464 15.4772 12.3184 15.201ZM23.6464 21.5431L22.1824 23.0398C22.1004 23.1231 21.9904 23.1698 21.8764 23.1698H12.6244C12.2404 23.1698 12.0464 22.6986 12.3184 22.4225L13.7824 20.9258C13.8644 20.8425 13.9744 20.7958 14.0884 20.7958H23.3404C23.7244 20.7958 23.9184 21.267 23.6464 21.5431Z",
    fill: "url(#paint0_linear_2064_7913)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2064_7913",
    x1: 12.8508,
    y1: 23.5826,
    x2: 23.2707,
    y2: 13.3206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB4EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10F4B1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2064_7913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.3077,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/SOL.8aa239ef6fc90a593f22941e5cc635bd.svg";
export { ForwardRef as ReactComponent };